@if (inited) {
    <sm-table class="height100p" [data]="table" (onRowSelect)="selectRow($event)">
    </sm-table>
}
